export const MAXIMUM_FILE_SIZE = 8097152;
export const ONE_MB_IN_BYTES = 1048576;
